<div class="wrapper">
  <app-scrollbar>
    <div class="heading">
      <!-- 解锁标题 -->
      <div class="title" *ngIf="!showPage2">{{ 'bonus_unlock' | translate }}LED</div>
      <!--介绍如何解锁led标题(可回上一步) -->
      <div class="title mutual-opacity onact96" (click)="showPage2 = false" *ngIf="showPage2">
        <i class="icon-arrow-left-simple"></i> {{ 'how_to_unlock' | translate }}
      </div>
      <div class="btn-close mutual-opacity onact96" (click)="close()">
        <i class="icon-error close-anim"></i>
      </div>
    </div>
    <div class="body" [appLoading]="loading">
      <!-- page-1 解锁金额页 -->
      <div class="page-1" *ngIf="!showPage2 && this.laterConfigInfo">
        <div class="main">
          <div class="top">
            <div>{{ 'led_unlock_with_betting' | translate }}</div>
            <!-- 连结到解锁介绍 -->
            <div class="mutual-opacity onact96" (click)="showPage2 = true">
              {{ 'how_to_unlock' | translate }} <i class="icon-arrow-right-simple"></i>
            </div>
          </div>
          <div class="unlock-area">
            <!-- 未解锁金额 -->
            <div class="txt">{{ 'unlockable_amount' | translate }}</div>
            <div [appLoading]="loading" style="height: 16px">
              <div class="coin" *ngIf="!loading">
                <img [src]="'LED' | currencyIcon" lazy="loading" alt="" /><span>{{
                  laterConfigInfo.unlockedAmount | currencyValue: 'LED'
                }}</span>
              </div>
            </div>

            <img class="led-pic" src="assets/temp5/led-pic.png" alt="" />
            <!-- 可解锁金额 -->
            <div class="txt color">{{ 'unlock' | translate }}</div>
            <div [appLoading]="loading" style="height: 16px">
              <div class="coin color" *ngIf="!loading">
                <img [src]="'LED' | currencyIcon" lazy="loading" alt="" /><span>{{
                  laterConfigInfo.lockedAmount | currencyValue: 'LED'
                }}</span>
              </div>
            </div>
            <div [appLoading]="loading" style="height: 44px">
              <customize-button
                *ngIf="!loading"
                class="final-btn"
                type="primary-linear"
                size="medium"
                minWidth="162px"
                (onClick)="receiveLed(laterConfigInfo.lockedAmount)"
              >
                {{ 'claim' | translate }}
              </customize-button>
            </div>
          </div>
        </div>
        <div class="note">
          <div>
            {{ 'unlock_amount' | translate }} = {{ 'valid_bet_amount' | translate }}*1%*{{ laterConfigInfo.lockRatio }}%
          </div>
          <div>{{ 'minimum_amount_for_withdrawal' | translate }}：{{ laterConfigInfo.minAmount }} LED</div>
        </div>
        <!-- LED纪录 -->
        <div class="history">
          <div class="tt">
            <div>{{ 'led_records' | translate }}</div>
            <div [appLoading]="loading" style="height: 16px">
              {{ 'total_claimed' | translate }}
              <div class="coin" *ngIf="!loading">
                <img [src]="'LED' | currencyIcon" lazy="loading" alt="" /><span>{{
                  laterConfigInfo.receiveAmount | currencyValue: 'LED'
                }}</span>
              </div>
            </div>
          </div>
          <div class="loading-wrap" [appLoading]="loading">
            <ng-container *ngIf="laterPageInfo.length > 0; else empty">
              <table>
                <thead>
                  <th>{{ 'dates' | translate }}</th>
                  <th>{{ 'order' | translate }}</th>
                  <th>{{ 'act_name' | translate }}</th>
                  <th>{{ 'amount' | translate }}</th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of laterPageInfo">
                    <td>{{ item.createTime | mdate: 'YYYY/MM/DD HH:mm:ss' }}</td>
                    <td>{{ item.orderNumber }}</td>
                    <td>{{ item.activitiesName }}</td>
                    <td>
                      <div class="coin">
                        <img [src]="'LED' | currencyIcon" lazy="loading" alt="" /><span class="value">{{
                          item.amount | currencyValue: 'LED'
                        }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
            <ng-template #empty>
              <app-empty class="led-empty" [smallText]="true"></app-empty>
            </ng-template>
          </div>
        </div>
        <div class="page" *ngIf="laterPageInfo.length > 0">
          <app-paginator
            [(page)]="paginator.page"
            [total]="paginator.total"
            [pageSize]="paginator.pageSize"
            [disabled]="loading"
            [loading]="loading"
            [alwaysWeb]="true"
            (onPageChange)="loadData()"
          >
          </app-paginator>
        </div>
      </div>
      <!-- page-2 介绍如何解锁页（纯文字介绍） -->
      <div class="page-2" *ngIf="showPage2 && this.laterConfigInfo">
        <!-- 可返回page-1 -->
        <div class="coin-pic">
          <div class="unlock-bonus mutual-opacity onact96-not" (click)="showPage2 = false">
            {{ 'bonus_unlock' | translate }}
          </div>
          <img src="assets/temp5/led-coin.png" alt="" />
          <div class="txt">1LED = 1USDT</div>
        </div>
        <div class="introduce">
          <div class="tt">{{ 'what_is_led' | translate }}</div>
          <div class="txt">LED（{{ 'led_dollar' | translate }}）{{ 'led_text_1' | translate }} 1 LED = 1 USDT</div>
          <div class="box">
            <div class="tt">{{ 'how_to_unlock' | translate }}</div>
            <div class="txt">
              {{ 'led_text_2' | translate }}
            </div>
            <div class="important">
              {{ 'unlock_amount' | translate }} = {{ 'valid_bet_amount' | translate }}*1%*{{
                laterConfigInfo.lockRatio
              }}%
            </div>
            <div class="tt">{{ 'led_text_3' | translate }}</div>
            <div class="txt">
              {{ 'led_text_4' | translate }}
            </div>
          </div>
          <div class="tt">{{ 'led_text_5' | translate }}</div>
          <div class="txt">{{ 'led_text_6' | translate }}</div>
        </div>
      </div>
    </div>
  </app-scrollbar>
</div>
